import { AccountInfo } from "@azure/msal-browser";
import { useCallback, useEffect, useState } from "react";
import { photoStorageService } from "../services/photoStorageService";
import { syncService } from "../services/syncService";
import { SyncStatus } from "../types/Photo";

interface SyncStatusData {
  pending: number;
  syncing: number;
  failed: number;
  isSyncing: boolean;
}

const NOTHING: SyncStatusData = {
  pending: 0,
  syncing: 0,
  failed: 0,
  isSyncing: false,
};

const countBy = (photos: { syncStatus: SyncStatus }[], status: SyncStatus) =>
  photos.filter((photo) => photo.syncStatus === status).length;

/**
 * Ce qui reste à faire partir, pour l'indicateur permanent.
 *
 * Aucun sondage périodique : la file d'envoi prévient à chaque changement
 * d'état de photo, et on relit. Un compteur qui tourne dans le vide coûte de la
 * batterie sur un téléphone qui n'a rien à envoyer.
 */
export const useSyncStatus = (account: AccountInfo | null) => {
  const [data, setData] = useState<SyncStatusData>(NOTHING);

  // L'identifiant, pas le compte : MSAL rend un objet neuf à chaque
  // rafraîchissement de jeton, et dépendre de lui relirait la base pour rien.
  const accountId = account?.homeAccountId;

  const refresh = useCallback(async () => {
    try {
      const photos = accountId
        ? await photoStorageService.getPhotosByAccount(accountId)
        : [];
      setData({
        pending: countBy(photos, SyncStatus.PENDING),
        syncing: countBy(photos, SyncStatus.SYNCING),
        failed: countBy(photos, SyncStatus.FAILED),
        isSyncing: syncService.getIsSyncing(),
      });
    } catch (error) {
      // L'indicateur ne doit pas faire tomber l'écran : la file, elle, garde
      // les photos, et le prochain changement d'état relira.
      console.error("Lecture de l'état d'envoi :", error);
    }
  }, [accountId]);

  // La file d'envoi est un magasin extérieur à React : cet effet en est
  // l'abonnement, et la première lecture est celle de l'état déjà en place.
  // Même situation que `AuthContext` avec les comptes MSAL — recopier un
  // magasin extérieur dans un état est précisément ce à quoi un effet sert.
  /* eslint-disable react-hooks/set-state-in-effect */
  useEffect(() => {
    refresh();
    return syncService.subscribe(() => void refresh());
  }, [refresh]);
  /* eslint-enable react-hooks/set-state-in-effect */

  return data;
};
